
import { Component, Vue } from "vue-property-decorator";
import { Bar } from "vue-chartjs/legacy";
import { dataVisualizationModule } from "@/store";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from "chart.js";

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

@Component({
  components: {
    Bar
  }
})
export default class AgeAtFirstDiagnosisChart extends Vue {
  chartDatas = {
    labels: [] as string[],
    datasets: [] as any[]
  };

  chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      }
    },
    scales: {
      y: {
        ticks: {
          precision: 0, // no decimals
          stepSize: 1,  // force step size of 1
          callback: function (value: number) {
            return Number.isInteger(value) ? value : '';
          }
        },
        beginAtZero: true
      }
    }
  };

  get rawChartData(): any[] {
    return dataVisualizationModule.getChartData("currentAgeCount");
  }

  get chartDataAvailable(): boolean {
    return (
        this.chartDatas.labels.length > 0 &&
        this.chartDatas.datasets.length > 0 &&
        this.chartDatas.datasets[0].data.length > 0
    );
  }

  async mounted() {
    try {
      await dataVisualizationModule.loadAll("currentAgeCount");

      const rawData = this.rawChartData;

      // ✅ Use only the count row (first row)
      if (Array.isArray(rawData) && rawData.length > 0 && rawData[0]) {
        const countsRow = rawData[0]; // First row = count
        const labels = Object.keys(countsRow);
        const data = Object.values(countsRow).map(val => Number(val));

        this.chartDatas = {
          labels,
          datasets: [
            {
              label: "Patient Count",
              backgroundColor: [
                '#ffac1c', '#ff6f00', '#ffd700', '#ff8c00', '#ffa07a',
                '#ffc107', '#cd5c5c', '#ffb6c1', '#d2b48c', '#deb887'
              ],
              data
            }
          ]
        };
      }
    } catch (e) {
      console.error("Failed to load chart data", e);
    }
  }

}
